module.exports = __webpack_public_path__ + "static/media/tickNew.328943ba.svg";